<script setup lang="ts">
import { ref, reactive, computed } from 'vue';
import type { Component } from 'vue';
import Inquiry from '@/javascripts/utils/inquiry';
import { useMobileFlag } from '@/javascripts/composables/browser';
import { useInquiryValidation } from '@/javascripts/composables/inquiry/validation';

// コンポーネント
import SlideIndicator from './fresh_slide_form/slide_indicator.vue';
import NameBirthYearSlide from './fresh_slide_form/slide1.vue';
import PrefCityPhoneEmailCommentSlide from './fresh_slide_form/slide2.vue';

const inquiry = reactive(new Inquiry);

const slideComponents: Component[] = [
  NameBirthYearSlide,
  PrefCityPhoneEmailCommentSlide,
];

/** 現在のスライドインデックス */
const currentSlideIndex = ref(0);
/** スライドの数 */
const maxSlide = slideComponents.length;
/** 現在のスライドコンポーネント */
const currentSlideComponent = computed(() => slideComponents[currentSlideIndex.value]);
/** トランジション名 */
const transitionName = ref<'next' | 'back'>('next');
/** 問い合わせのバリデーション */
const v$ = useInquiryValidation(inquiry);

/** `next`イベントハンドラー */
const next = () => {
  transitionName.value = 'next';
  currentSlideIndex.value++;
}

/** `next`イベントハンドラー */
const back = () => {
  transitionName.value = 'back';
  currentSlideIndex.value--;
}

/** モバイルかどうか */
const isMobile = useMobileFlag();
/** フォーム要素 */
const formBody = ref<HTMLElement | null>(null);
/** モバイルの場合はフォームのトップにスクロールさせる */
const scrollToFormTopWhenMobile = () => {
  if(isMobile.value) formBody.value?.scrollIntoView();
}
</script>

<template>
  <div class="form-inner" ref="formBody">
    <div id="multi-box-form">
        <form>
          <div class="inquiry">
            <h2 class="inquiry-heading"><span class="font-weight-bold">簡単<strong class="font-weight-bold">2</strong>STEP!</span>無料登録(30秒)<br class="sp-block">はこちらから</h2>
            <div class="inquiry-form">
              <SlideIndicator :max="maxSlide" :currentSlideIndex="currentSlideIndex" />
              <Transition :name="transitionName" mode="out-in" @enter="scrollToFormTopWhenMobile">
                <component
                  :is="currentSlideComponent"
                  :inquiry="inquiry"
                  :v$="v$"
                  @next="next"
                  @back="back"
                />
              </Transition>
            </div>
          </div>
        </form>
      </div>
  </div>
</template>

<style>
.next-enter-active, .next-leave-active, .back-enter-active, .back-leave-active {
  transition: all .3s ease;
}

.next-enter, .next-leave-to, .back-enter, .back-leave-to {
  opacity: 0;
}

.next-leave-to {
  transform: translateX(-70px);
}

.back-leave-to {
  transform: translateX(70px);
}
</style>
